document.addEventListener('DOMContentLoaded', function () {
  const icons = document.querySelectorAll('.hm-stats-icon');
  icons.forEach(function (icon) {
    const card = icon.closest('.hm-stats-card');
    card.addEventListener('mouseenter', function () {
      icon.style.transform = 'translateY(-8px)';
      icon.style.transition = 'transform 0.3s ease';
    });
    card.addEventListener('mouseleave', function () {
      icon.style.transform = 'translateY(0)';
      icon.style.transition = 'transform 0.3s ease';
    });
  });
});

document.addEventListener('DOMContentLoaded', function () {

  function countUp(element, target, suffix, duration) {
    let start = 0;
    const increment = target / (duration / 16);

    const timer = setInterval(() => {
      start += increment;
      if (start >= target) {
        start = target;
        clearInterval(timer);
      }
      element.textContent = Math.floor(start) + suffix;
    }, 16);
  }

  function getSuffixAndNumber(text) {
    // "21+" → number: 21, suffix: "+"
    // "500+" → number: 500, suffix: "+"
    // "10K+" → number: 10, suffix: "K+"
    const match = text.match(/^(\d+)(.*)$/);
    if (match) {
      return {
        number: parseInt(match[1]),
        suffix: match[2] || ''
      };
    }
    return { number: 0, suffix: '' };
  }

  const numberElements = document.querySelectorAll('.hm-stats-number');

  // Original values save karo
  numberElements.forEach(el => {
    el.dataset.original = el.textContent.trim();
  });

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const el = entry.target;
        const original = el.dataset.original;
        const { number, suffix } = getSuffixAndNumber(original);

        // 0 se start karo
        el.textContent = '0' + suffix;
        countUp(el, number, suffix, 2000); // 2000ms = 2 second

        observer.unobserve(el);
      }
    });
  }, { threshold: 0.3 });

  numberElements.forEach(el => observer.observe(el));
});
